import {Checkbox, FormControl, FormLabel, Grid, Typography} from '@material-ui/core'
import {DatePicker} from '@material-ui/pickers'
import React, {useContext, useEffect, useState} from 'react'
import {OrderContext} from '../OrderContext'
import {CancelButton, NextButton, PreviousButton} from '../StepperButtons'
import AddressCard from './AddressCard'
import ControlContainer from '../components/ControlContainer'
import CheckBoxOutlineBlankSharpIcon from '@material-ui/icons/CheckBoxOutlineBlankSharp';
import CheckBoxSharpIcon from '@material-ui/icons/CheckBoxSharp';
import {useTranslation} from 'react-i18next'
import {addBusinessDays, addDays, isWeekend} from "date-fns";

const PickupSelector = () => {
    const {
        pickup,
        setPickup,
        addresses,
        setShipTo,
        orderType,
        customer,
        pickupDate,
        setPickupDate
    } = useContext(OrderContext)
    const [sameAddress, setSameAddress] = useState(false)
    const {t} = useTranslation()

    useEffect(() => {
        if (pickup) setSameAddress(false)
    }, [pickup])

    return (
        <>
            <Typography variant='h4' style={{marginBottom: 60}}>{t('select_pickup_address')}:</Typography>

            <Grid container spacing={3}>
                <Grid item xs={12} sm={6} md={4}>
                    <div style={{
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        <div style={{display: 'flex'}}>
                            <Checkbox
                                color='primary'
                                checked={pickup === 'NoPickup'}
                                onChange={e => setPickup((e.target.checked ? 'NoPickup' : (addresses?.length ? addresses[0].customer : 'NoPickup')))}
                                icon={<CheckBoxOutlineBlankSharpIcon fontSize='large'/>}
                                checkedIcon={<CheckBoxSharpIcon fontSize='large'/>}
                            />
                            <br/>
                            <div style={{width: '14em', marginLeft: 15}}>
                                <span>{t('no_pickup')}</span>
                                <br/>
                                {customer.showVenlo && <span>{t('no_pickup_address')}</span>}
                            </div>
                        </div>
                    </div>
                </Grid>

                {addresses?.map((a, i) =>
                    <Grid item xs={12} sm={6} md={4} key={i}>
                        <AddressCard address={a} active={pickup === a.customer}
                                     selectText={t('select_this_pickup_address')} onSelect={a => setPickup(a)}/>
                    </Grid>
                )}
            </Grid>

            {orderType === 'Exchange' && pickup !== 'NoPickup' &&
                <div style={{display: 'flex', flexDirection: 'row-reverse', alignItems: 'center', marginTop: 30}}>
                    <div style={{width: '14em'}}>
                        <p>{t('shipping_address_same_pickup')}</p>
                    </div>
                    <Checkbox
                        color='primary'
                        checked={sameAddress}
                        disabled={pickup === 'NoPickup'}
                        onChange={e => setSameAddress(e.target.checked)}
                        icon={<CheckBoxOutlineBlankSharpIcon fontSize='large'/>}
                        checkedIcon={<CheckBoxSharpIcon fontSize='large'/>}
                    />
                </div>
            }

            {pickup !== 'NoPickup' &&
                <FormControl>
                    <FormLabel>{t('requested_pickup_date')}</FormLabel>
                    <DatePicker
                        disableToolbar
                        autoOk
                        format="P"
                        minDate={addBusinessDays(new Date(), 1)}
                        maxDate={addDays(new Date(), 30)}
                        shouldDisableDate={d => isWeekend(d as Date)}
                        variant="inline"
                        margin="normal"
                        value={pickupDate}
                        onChange={(d) => setPickupDate(!!d ? d : addBusinessDays(new Date(), 1))}
                    />
                    <Typography variant='subtitle1'>{t('date_disclaimer')}</Typography>
                </FormControl>
            }

            <ControlContainer>
                <NextButton disabled={!pickup} increments={sameAddress ? 2 : 1} before={() => {
                    if (sameAddress) setShipTo(pickup)
                }}/>
                <PreviousButton/>
                <CancelButton/>
            </ControlContainer>
        </>
    )
}

export default PickupSelector
